import { ChangeEvent, Dispatch, SetStateAction } from "react";
import CustomLabel from "../../common/CustomLabel";
import { FilterCriteria } from "../../../types";
import CustomAccordion from "../../common/CustomAccordion";

const ReportReporterDetailsFilter = ({
  filterCriteria,
  setFilterCriteria,
}: {
  filterCriteria: FilterCriteria;
  setFilterCriteria: Dispatch<SetStateAction<FilterCriteria>>;
}) => {
  const handleReporterDetailsChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFilterCriteria((prev) => ({
      ...prev,
      reporterDetails: {
        ...prev.reporterDetails,
        [name]: value,
      },
    }));
  };

  return (
    <CustomAccordion label="Reporter Details" defaultOpen={true}>
      <div className="flex flex-col gap-4">
        <CustomLabel
          labelText="Reporter Role"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="role"
            placeholder="Select reporter role"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.reporterDetails.role}
            onChange={handleReporterDetailsChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Reporter Gender"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="gender"
            placeholder="Select reporter gender"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.reporterDetails.gender}
            onChange={handleReporterDetailsChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Reporter Age"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="age"
            placeholder="Select reporter age"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.reporterDetails.age}
            onChange={handleReporterDetailsChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Reporter Phone"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="phone"
            placeholder="Select reporter phone"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.reporterDetails.phone}
            onChange={handleReporterDetailsChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Reporter Email"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="email"
            placeholder="Select reporter email"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.reporterDetails.email}
            onChange={handleReporterDetailsChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Reporter Ethnicity"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="ethnicity"
            placeholder="Select reporter ethnicity"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.reporterDetails.ethnicity}
            onChange={handleReporterDetailsChange}
          />
        </CustomLabel>
      </div>
    </CustomAccordion>
  );
};

export default ReportReporterDetailsFilter;
